/* eslint-disable no-nested-ternary */
import { Controller } from "react-hook-form";
import {
  BlueBirdTheme, Checkbox, Dropdown, Form, Radio, RadioGroup, Typography,
} from "@kitbird/core";
import styled from "styled-components";
import { FormGroup, FormSection, FormWrapper } from "../../../../../components/Form/Form.style";
import { useTransactionCode } from "../../hooks/Provider";
import { EntryType } from "../../../../../enums/common";

const { danger } = BlueBirdTheme.colors;

const TextOnlyWrapper = styled.div`
  div > div { border: none; }
`;
const TransactionCodeForm = () => {
  const {
    methods,
    rangeCodes,
    rangeCodeQuery,
    modalConfig,
    onSubmit,
  } = useTransactionCode();

  const {
    handleSubmit,
    setValue,
    getValues,
    register,
    formState: { errors },
    watch,
    control,
  } = methods;

  const handleEntryTypeChange = (val: string) => {
    const currentVal = getValues("sap_shkzg");
    if (!currentVal) setValue("sap_shkzg", val, { shouldValidate: true });
    else if (currentVal === val) setValue("sap_shkzg", "", { shouldValidate: true });
    else if (currentVal === EntryType.DEBIT_KREDIT && val === EntryType.DEBIT) setValue("sap_shkzg", EntryType.KREDIT, { shouldValidate: true });
    else if (currentVal === EntryType.DEBIT_KREDIT && val === EntryType.KREDIT) setValue("sap_shkzg", EntryType.DEBIT, { shouldValidate: true });
    else if (currentVal !== val) setValue("sap_shkzg", EntryType.DEBIT_KREDIT, { shouldValidate: true });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormSection style={{ overflow: "unset" }}>
        <FormGroup>
          <FormWrapper>
            <Form
              {...register("gnlldr")}
              id="gnlldr"
              label="Akun GL"
              value={watch("gnlldr") || ""}
              autoComplete="off"
              maxLength={10}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                register("gnlldr").onChange(e);
              }}
              error={errors.gnlldr && { message: errors.gnlldr.message || "" }}
            />
          </FormWrapper>
          <FormWrapper>
            {modalConfig?.type === "UPDATE"
              && <TextOnlyWrapper>
                <Form
                  id="trx_code"
                  label="Kode transaksi"
                  value={modalConfig.row?.trx_code}
                  readOnly
                />
              </TextOnlyWrapper>
            }
          </FormWrapper>
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <div style={{ display: "flex" }}>
              <Checkbox
                {...register("sap_shkzg")}
                label="Debit"
                value={EntryType.DEBIT}
                onChange={(e) => handleEntryTypeChange(e.target.value)}
                checked={watch("sap_shkzg") === EntryType.DEBIT_KREDIT || watch("sap_shkzg")?.includes(EntryType.DEBIT)}
              />
              <Checkbox
                {...register("sap_shkzg")}
                label="Kredit"
                value={EntryType.KREDIT}
                onChange={(e) => handleEntryTypeChange(e.target.value)}
                checked={watch("sap_shkzg") === EntryType.DEBIT_KREDIT || watch("sap_shkzg")?.includes(EntryType.KREDIT)}
              />
            </div>
            {(errors.sap_shkzg)
              && <Typography level={7} color={danger[500]}>
                Harap memilih Jenis transaksi
              </Typography>
            }
          </FormWrapper>
          <FormWrapper />
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <Form
              {...register("trx_desc")}
              id="trx_desc"
              label="Deskripsi"
              maxLength={250}
              value={watch("trx_desc") || ""}
              autoComplete="off"
              error={errors.trx_desc && { message: errors.trx_desc.message || "" }}
            />
          </FormWrapper>
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <Form
              {...register("sap_bktxt")}
              id="sap_bktxt"
              label="Detail"
              maxLength={250}
              value={watch("sap_bktxt") || ""}
              autoComplete="off"
              error={errors.sap_bktxt && { message: errors.sap_bktxt.message || "" }}
            />
          </FormWrapper>
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <Dropdown
              {...register("range_code")}
              id="range_code"
              label="Kode range"
              value={watch("range_code") || ""}
              autoComplete="off"
              allowSearch
              hasNextPage={rangeCodeQuery.hasNextPage}
              fetchNextPage={rangeCodeQuery.fetchNextPage}
              onSelected={(opt) => setValue("range_code", String(opt.value), { shouldValidate: true })}
              options={rangeCodes?.map((item) => ({
                label: item,
                value: item,
              })) || []}
              error={errors.range_code && { message: errors.range_code.message || "" }}
            />
          </FormWrapper>
          <FormWrapper />
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <div>
              <Controller
                name="lifnr"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      value={String(field.value ?? "")}
                      title="lifnnr (Nomor vendor)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.lifnr?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
          <FormWrapper>
            <div>
              <Controller
                name="kunnr"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      value={String(field.value ?? "")}
                      title="kunnr (nomor customer)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.kunnr?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <div>
              <Controller
                name="prctr"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      value={String(field.value ?? "")}
                      title="prctr (Profit center)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.prctr?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
          <FormWrapper>
            <div>
              <Controller
                name="idtrx1"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange((e.target.value))}
                      value={String(field.value ?? "")}
                      title="idtrx1 (ID transaksi 1)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.idtrx1?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
        </FormGroup>
        <FormGroup>
          <FormWrapper>
            <div>
              <Controller
                name="idtrx2"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      value={String(field.value ?? "")}
                      title="idtrx2 (ID transaksi 2)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.idtrx2?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
          <FormWrapper>
            <div>
              <Controller
                name="idtrx3"
                control={control}
                render={({ field }) => (
                  <>
                    <RadioGroup
                      {...field}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      value={String(field.value ?? "")}
                      title="idtrx3 (ID transaksi 3)"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Radio label="True" value={"1"} />
                        <Radio label="False" value={"0"} />
                      </div>
                    </RadioGroup>
                    <Typography level={7} color={danger[500]}>{errors.idtrx3?.message}</Typography>
                  </>
                )}
              />
            </div>
          </FormWrapper>
        </FormGroup>
      </FormSection>
    </form>
  );
};

export default TransactionCodeForm;
